export const TRY = new Intl.NumberFormat("tr-TR", {
  style: "currency",
  currency: "TRY",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const fmt = (n) => TRY.format(Number(n || 0));

export const fmtNum = (n) =>
  new Intl.NumberFormat("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Number(n || 0)
  );

export function computeRow(r) {
  const kalan = (Number(r.icra_tutari) || 0) - (Number(r.tahsilat) || 0);
  const brut_risk = (Number(r.alis_fiyati) || 0) - (Number(r.odenen) || 0);
  const net_risk = brut_risk - (Number(r.tahsilat) || 0);
  const kar = (Number(r.satis_fiyati) || 0) - (Number(r.alis_fiyati) || 0);
  const faiz = (Number(r.asil_alacak) || 0) * ((Number(r.faiz_orani) || 48) / 100);
  return { kalan, brut_risk, net_risk, kar, faiz };
}

export const fmtDate = (s) => {
  if (!s) return "-";
  try {
    return new Date(s).toLocaleDateString("tr-TR");
  } catch {
    return s;
  }
};

export const DURUM_COLORS = {
  "Ödendi": "#2F6E4E",
  "Kısmi Ödendi": "#B8933F",
  "Ödenmedi": "#8C8377",
  "Vadesi Geçti": "#A63A3A",
};
